<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div
          class="form-group mx-4"
          :class="{'has-error has-feedback': cardNumber.error, 'has-success has-feedback': cardNumber.complete}"
        >
          <label for="card-number">Credit Card Number</label>
          <span id="card-number" class="form-control"></span>

          <span
            v-if="cardNumber.complete || cardNumber.error"
            :class="{'glyphicon-ok': cardNumber.complete, 'glyphicon-remove': cardNumber.error}"
            class="glyphicon form-control-feedback"
          ></span>

          <span v-if="cardNumber.error" class="help-block">
            {{ cardNumber.error.message }}
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div
          class="form-group"
          :class="{'has-error has-feedback': expiration.error, 'has-success has-feedback': expiration.complete}"
        >
          <label for="expiration">Expiration Date</label>
          <span id="expiration" class="form-control"></span>

          <span
            v-if="expiration.complete || expiration.error"
            :class="{'glyphicon-ok': expiration.complete, 'glyphicon-remove': expiration.error}"
            class="glyphicon form-control-feedback"
          ></span>

          <span v-if="expiration.error" class="help-block">
            {{ expiration.error.message }}
          </span>
        </div>
      </div>
      <div class="col-sm-6">
        <div
          class="form-group"
          :class="{'has-error has-feedback': cvc.error, 'has-success has-feedback': cvc.complete}"
        >
          <label for="cvc">CVC</label>
          <span id="cvc" class="form-control"></span>

          <span
            v-if="cvc.complete || cvc.error"
            :class="{'glyphicon-ok': cvc.complete, 'glyphicon-remove': cvc.error}"
            class="glyphicon form-control-feedback"
          ></span>

          <span v-if="cvc.error" class="help-block">
            {{ cvc.error.message }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const style = {
  base: {
    fontFamily: `"Source Sans Pro", HelveticaNeue-Light, "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif`,
    fontSize: '16px',
    color: '#43454b',
    '::placeholder': {
      color: '#999999',
    },
  },
  invalid: {
    color: '#43454b',
  },
};

export default {
  name: 'credit-card-form',
  data() {
    return {
      cardNumber: {},
      expiration: {},
      cvc: {},
    };
  },
  props: {
    stripeElements: {
      type: Object,
    },
  },
  computed: {
    formValid() {
      return this.cardNumber.complete && this.expiration.complete && this.cvc.complete;
    },
  },
  watch: {
    formValid(valid) {
      this.$emit('validity-change', valid);
    },
    stripeElements(stripeElements) {
      if (stripeElements) {
        this.initStripeElements();
      }
    },
  },
  methods: {
    createStripeElement(type, selector, onChange) {
      const element = this.stripeElements.create(type, {style});
      element.mount(selector);
      element.on('change', onChange);
    },
    initStripeElements() {
      this.createStripeElement('cardNumber', '#card-number', event => (this.cardNumber = event));
      this.createStripeElement('cardExpiry', '#expiration', event => (this.expiration = event));
      this.createStripeElement('cardCvc', '#cvc', event => (this.cvc = event));
    },
  },
};
</script>

<style lang="scss" scoped>
.StripeElement {
  height: 40px;
  padding: 0.6em;

  &--focus {
    border-color: #66cccc;
    outline: 0;
    transition: border-color 0.15s ease-in-out;
  }
}

.form-group {
  .form-control-feedback {
    top: 41px;
    visibility: visible;
  }
}
</style>
